<template>
  <v-app-bar
    class="app-header"
    :height="hasMobile ? '70' : '140'"
    :color="hasMobile ? 'secondary darken-4' : 'transparent'"
    :app="hasMobile"
    flat
  >
    <!-- Drawer -->
    <v-btn
      v-if="hasMobile"
      class="app-header__menu"
      @click.stop="showDrawer"
      aria-label="القائمة الرئيسية"
      color="secondary darken-5"
      icon
    >
      <v-icon size="32" color="primary">mdi-menu</v-icon>
    </v-btn>
    <!-- Tabs -->
    <v-tabs
      v-model="activeTab"
      :slider-size="hasActiveTab ? 2 : 0"
      :show-arrows="false"
      background-color="transparent"
      class="app-header__tabs hidden-xs-only"
      optional
      left
    >
      <v-tab
        v-for="(item, index) in navItems"
        :key="index"
        :to="item.path"
        :aria-label="item.title"
        class="app-header__tab px-sm-3 px-md-5"
        exact
      >
        <v-icon
          v-if="item.forceIcon"
          class="app-header__tab-icon"
          color="white"
          size="24"
        >{{ item.icon }}</v-icon>
        <span v-else class="app-header__tab-text white--text subtitle-2">{{ item.title }}</span>
      </v-tab>
    </v-tabs>
    <!-- Margin -->
    <div class="app-header__margin flex-grow-1"></div>
    <!-- Title -->
    <v-toolbar-title class="app-header__logo flex-grow-0">
      <router-link aria-label="الرئيسية" :to="{ name: 'Home' }">
        <brand :fill-white="isHome" />
      </router-link>
    </v-toolbar-title>
  </v-app-bar>
</template>

<script>
// deps
import { mapGetters, mapMutations } from 'vuex'
// components
import Brand from '@/components/ui/Brand'
// export
export default {
  // name
  name: 'Header',
  // components
  components: {
    brand: Brand
  },
  // data
  data() {
    return {
      activeTab: null
    }
  },
  computed: {
    // mapGetters
    ...mapGetters({
      status: 'getDrawerStatus',
      getNav: 'getNav'
    }),
    // nav items
    navItems() {
      return this.getNav(['global'])
    },
    hasActiveTab() {
      return this.activeTab === this.$route.fullPath
    },
    // drawer status
    drawerStatus: {
      get: function() {
        return this.status
      },
      set: function(value) {
        this.setDrawerStatus(value)
      }
    }
  },
  // mounted
  mounted() {
    this.$el.querySelector('.v-toolbar__content').classList.add('container')
  },
  // methods
  methods: {
    // mapMutations
    ...mapMutations(['setDrawerStatus']),
    // show drawer
    showDrawer() {
      this.drawerStatus = true
    }
  }
}
</script>

<style lang="scss">
.app-header .v-toolbar__content,
.app-header .v-toolbar__extension {
  padding-right: 24px;
  padding-left: 24px;
}

.app-header {
  z-index: 1;
  transition-duration: 350ms !important;
}
.v-application header.app-header:not(.v-app-bar--is-scrolled) {
  background-color: transparent !important;
}

.app-header .app-header__logo {
  overflow: visible;
}
.app-header .app-header__logo .brand {
  width: 200px;
}

// Screens
@include sm-down {
  .app-header .app-header__logo .brand {
    width: 180px;
  }
}
@include xs {
  .app-header .app-header__logo .brand {
    width: 150px;
  }
}

.app-header .v-slide-group__prev--disabled {
  display: none !important;
}
</style>
